import React, { useCallback } from 'react';
import { EntityTypeType } from '~/components/Admin';
import { ServicesContext } from '~/services';

export interface RoleEntityType {
    id: number;
    name: string;
    tin?: string;
}
export const useGetRoleEntities = () => {
    const services = React.useContext(ServicesContext);
    const cachedMarkets = React.useRef<RoleEntityType[]>();

    const getRoleEntities = useCallback(
        async (entityType: EntityTypeType) => {
            const result = await services.api.call({
                method: 'get',
                url: `/api/${entityType}s`,
                params: { items_per_page: 1000000 },
                data: {},
                headers: {
                    'Content-Type': 'application/ld+json',
                },
            });
            const entities: RoleEntityType[] = result.data['hydra:member'];
            return entities;
        },
        [services.api]
    );

    const getCachedMarkets = useCallback(async () => {
        if (Array.isArray(cachedMarkets.current)) {
            return cachedMarkets.current;
        }
        const result = await getRoleEntities('market');
        cachedMarkets.current = result;
        return result;
    }, [getRoleEntities]);

    return { getRoleEntities, getCachedMarkets };
};
